import { Link, useLocation } from "react-router-dom";
import { BrandMark } from "@/components/Navbar";

export default function Footer() {
  const { pathname } = useLocation();
  const isLanding = pathname === "/";

  return (
    <footer
      data-testid="site-footer"
      className="bg-[#F7F5F2] border-t border-[#E5E0D8]"
    >
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-14">
        <div className="grid grid-cols-12 gap-8 items-start">
          <div className="col-span-12 md:col-span-5">
            <BrandMark />
            <p className="mt-4 font-body text-sm text-[#5C5C5C] max-w-md">
              A quiet remembering for artists who&rsquo;ve been listening less.
              A small doorway back to the work, and the truth underneath it.
            </p>
          </div>

          <div className="col-span-6 md:col-span-3">
            <div className="text-[10px] uppercase tracking-[0.3em] text-[#5C5C5C] font-body">
              The Academy
            </div>
            <ul className="mt-3 space-y-2 font-body text-sm text-[#1A1A1A]">
              <li>
                <Link to="/" className="hover:text-[#1FA5B8]" data-testid="footer-home">
                  The 5-Minute Reset
                </Link>
              </li>
              <li>
                <Link to="/the-deeper-reactivation" className="hover:text-[#1FA5B8]" data-testid="footer-deeper">
                  The Deeper Reactivation
                </Link>
              </li>
              <li>
                <Link to="/work-with-me" className="hover:text-[#1FA5B8]" data-testid="footer-work">
                  Work with me
                </Link>
              </li>
              <li>
                <Link to="/welcome" className="hover:text-[#1FA5B8]" data-testid="footer-welcome">
                  The Welcome
                </Link>
              </li>
            </ul>
          </div>

          <div className="col-span-6 md:col-span-2">
            <div className="text-[10px] uppercase tracking-[0.3em] text-[#5C5C5C] font-body">
              Listen  ·  Wait
            </div>
            <ul className="mt-3 space-y-2 font-body text-sm text-[#1A1A1A]">
              <li>
                <Link to="/born-to-create" className="hover:text-[#1FA5B8]" data-testid="footer-podcast">
                  Born to Create
                </Link>
              </li>
              <li>
                <Link to="/wynn" className="hover:text-[#1FA5B8]" data-testid="footer-wynn">
                  WYNN
                </Link>
              </li>
            </ul>
          </div>

          <div className="col-span-12 md:col-span-2">
            <div className="text-[10px] uppercase tracking-[0.3em] text-[#5C5C5C] font-body">
              Reach
            </div>
            <ul className="mt-3 space-y-2 font-body text-sm text-[#1A1A1A]">
              <li>hello@awakenedartist.academy</li>
              {isLanding && (
                <>
                  <li><a href="#philosophy" className="hover:text-[#1FA5B8]">The Signs</a></li>
                  <li><a href="#faq" className="hover:text-[#1FA5B8]">FAQ</a></li>
                </>
              )}
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-[#E5E0D8] flex flex-col md:flex-row md:items-center md:justify-between gap-3">
          <div className="font-body text-xs text-[#5C5C5C]">
            © {new Date().getFullYear()} Awakened Artist Academy. All rights reserved.
          </div>
          <div className="font-body text-[10px] uppercase tracking-[0.3em] text-[#5C5C5C]">
            Reawaken your creativity
          </div>
        </div>
      </div>
    </footer>
  );
}
